let configSettings = require('../../static/config.json');
import  baseHttp  from '@/services/baseHttp';
import CommonFactory from './common.factory';

export default{
  name:'HttpFactory',
  mixins: [CommonFactory],
	data(){
		return {
      baseUrl:null,

    };
  },
  created(){
    let _self=this;
    _self.initHttpSettings();
  },
  methods:{
    initHttpSettings(){
      let _self=this;
      let requestType=_self.$route.matched[0].path;
      // if(_self.zendeskInfo.credentials!=null){
      //   requestType=`${_self.zendeskInfo.credentials.requestType}/`;
      // }
      
      _self.baseUrl=`${configSettings.apiUrl}${requestType}`
      baseHttp.initHttpSettings(requestType);
    },
    initHttpSettings_noPrefix(donotPrefix){
      let _self=this;
      let requestType=_self.$route.matched[0].path;
      // if(_self.zendeskInfo.credentials!=null){
      //   requestType=`${_self.zendeskInfo.credentials.requestType}/`;
      // }
      
      if(donotPrefix){
        _self.baseUrl=`${configSettings.apiUrl}`
        baseHttp.initHttpSettings('');  
      }else{
        _self.baseUrl=`${configSettings.apiUrl}${requestType}`
        baseHttp.initHttpSettings(requestType);
      }
    },
    postFile(action,data) {
      this.fn().showLoader(true);
      return baseHttp.postFile(action,data);
    },
    search(action,queryData) {
      this.fn().showLoader(true);
      return baseHttp.search(action,queryData);
    },
    get(action) {
      this.fn().showLoader(true);
      return baseHttp.get(action);
    },
    post(action,data,hideLoading) {
      this.fn().showLoader(true);
      return baseHttp.post(action,data);
    },
    put(action,data,hideLoading) {
      this.fn().showLoader(true);
      return baseHttp.put(action,data);
    },
    delete(action) {
      this.fn().showLoader(true);
      return baseHttp.delete(action);
    },
    commonErrorMsgDisp(error){
      let _self=this;
      _self.fn().showLoader(false);
      let errors=new Array();
      if (error && error.response) {
        if(error.response.data.result){
          errors.push(error.response.data.result);
        }
        if(error.response.data.Data){
          errors.push(error.response.data.Data);
        }
        
        if(error.response.data.Errors){
          for (var key in error.response.data.Errors) {
            let erMsg = error.response.data.Errors[key].Message;
            errors.push(erMsg);
            
          }
        }
        if(errors.length<=0 && error.response.data){
          errors.push(error.response.data);
        }
      }
      else if(error && error.message){
        errors.push(error.message);
      }else {
        errors.push('Server response null');
      }
      _self.userMsg={show:true,type:'danger',list:errors.length>0?errors:_self.userMsg={show:true,type:'danger',list:['An error occurred!! Please try again later']}}
      
      return errors;
  }
  }
}